<template>
  <div>
    <v-row no-gutters>
      <v-col
        cols="12"
        md="6"
        class="text-start"
        style="display: flex; align-items: center"
      >
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("course.allCourses") }}
        </span>
      </v-col>

      <v-col cols="12" md="6" v-if="havePermissionCreateTrainingRegistration">
        <div class="d-flex justify-start justify-md-end pt-3">
          <v-btn
            depressed
            color="primary"
            style="text-transform: unset"
            class="rounded-lg font-weight-normal"
            @click="assignCourse"
          >
            <v-icon left> mdi-plus </v-icon>
            {{ $t("course.assignedCourses.assignCourse") }}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="havePermissionGetTrainingRegistrations">
      <v-col>
        <EmployeeCoursesFilters @filter="filterBy" :loading="loading" />
      </v-col>
    </v-row>

    <div v-if="havePermissionGetTrainingRegistrations">
      <div style="overflow-x: auto; overflow-y: hidden">
        <div>
          <v-card
            flat
            class="rounded-lg mt-5 primary--text"
            style="min-width: 100%; max-width: fit-content; width: fit-content"
          >
            <div
              class="text-center d-flex align-center py-2"
              style="min-height: 65px; width: fit-content"
            >
              <div class="text-start ps-7" style="width: 300px">
                {{ $t("user.registration.training") }}
              </div>

              <div class="text-start" style="width: 250px">
                {{ $t("course.trainer") }}
              </div>

              <div class="text-start pe-3" style="width: 150px">
                {{ $t("batch.batchNumber") }}
              </div>

              <div style="width: 200px">
                {{ $t("user.registration.registrationStatus") }}
              </div>

              <div style="width: 200px">
                {{ $t("user.registration.employeeId") }}
              </div>
              <div style="width: 200px">
                {{ $t("user.registration.startDate") }}
              </div>
              <!--              <div style="width: 200px">
                {{ $t("user.registration.endDate") }}
              </div>-->
              <div style="width: 200px">
                {{ $t("reports.certificateExpiryDate") }}
              </div>
              <div class="px-0 pe-5" style="width: 200px">
                {{ $t("user.profile.certificateDownload") }}
              </div>
              <div style="width: 200px">
                {{ $t("invoice.invoiceDate") }}
              </div>
              <div style="width: 200px">
                {{ $t("user.profile.invoiceDownload") }}
              </div>

              <div v-if="havePermissionDeleteTrainingRegistration">
                <v-btn icon depressed disabled style="visibility: hidden">
                  <v-icon> mdi-trash-can-outline </v-icon>
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>

        <div v-if="!loading && datas.length">
          <div v-for="(data, index) in datas" :key="index">
            <CourseCard
              :registrationData="data"
              @afterStatusUpdate="onStatusUpdate"
              @onDelete="deleteTrainingRegistration"
              @error="onError"
            />
          </div>
        </div>

        <div
          v-else-if="!loading && !datas.length"
          class="textLight--text font-weight-medium"
        >
          {{ $t("noItems") }}
        </div>

        <div v-else-if="loading && !datas.length">
          <v-progress-circular indeterminate color="primary" />
        </div>
      </div>

      <div v-if="datas && datas.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </div>
    </div>

    <div v-else class="subtitle-1 textLight--text">
      {{ $t("youHaveNoPermission") }}
    </div>

    <AssignNewCourse
      v-if="assignCourseModal"
      @close="closeModel"
      @afterCreate="onNewAssigning"
      :employee="employeeId"
      :employeeOrganization="employeeOrganizationId"
    />

    <v-snackbar
      :value="snackbarError"
      @input="resetSnackbar"
      timeout="3000"
      color="error"
    >
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="resetSnackbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { hasPermission } from "@/app/user-module/helpers/authHelper";
import { deleteTrainingRegistration } from "@/app/course-module/methods/deleteTrainingRegistration";

import CourseCard from "./EmployeeCourseCard.vue";
import AssignNewCourse from "./AssignNewCourse.vue";
import EmployeeCoursesFilters from "./EmployeeCoursesFilters.vue";
import Pagination from "../../../core-module/components/Pagination.vue";

export default {
  components: {
    CourseCard,
    AssignNewCourse,
    EmployeeCoursesFilters,
    Pagination,
  },
  data() {
    return {
      loading: true,
      snackbarError: false,
      snackbarErrorMessage: null,
      datas: [],
      totalCount: null,
      variables: {
        limit: 10,
        skip: 0,
      },
      assignCourseModal: false,
      filterInputs: {
        employee: this.employeeId,
      },
      totalPages: 0,
    };
  },
  props: {
    employeeId: {
      type: String,
      required: true,
    },
    employeeOrganizationId: String,
  },
  apollo: {
    getTrainingRegistrations() {
      return {
        query: require("../../../course-module/api/query/getTrainingRegistrations.gql"),
        variables: {
          limit: 10,
          skip: 0,
          filterInput: this.filterInputs,
        },
        // skip: () =>
        //   this.havePermissionGetTrainingRegistrations ? false : true,
        result({ data, loading }) {
          if (
            data &&
            data.getTrainingRegistrations &&
            data.getTrainingRegistrations.trainingRegistrations
          ) {
            this.datas = data.getTrainingRegistrations.trainingRegistrations;
            this.totalCount = data.getTrainingRegistrations.totalCount;
            let pagesVal = this.totalCount / this.variables.limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          } else {
            this.$emit("errorLoading");
          }

          this.loading = loading;
        },
      };
    },
  },
  computed: {
    havePermissionCreateTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionGetTrainingRegistrations() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_TRAINING_REGISTRATIONS"],
      });
    },
    havePermissionDeleteTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    resetSnackbar() {
      this.snackbarError = false;
      this.snackbarErrorMessage = null;
    },
    onError(type) {
      let msg = null;

      if (type === "delete") {
        msg = this.$t("deleteFailed");
      } else if (type === "update") {
        msg = this.$t("updateFailed");
      }

      this.snackbarError = true;
      this.snackbarErrorMessage = msg;
    },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    assignCourse() {
      this.assignCourseModal = true;
    },
    onStatusUpdate() {
      this.refetch();
      this.$emit("onStatusUpdate");
    },
    filterBy(key, value) {
      if (key === "training") {
        if (!value) {
          delete this.filterInputs?.training;
        } else {
          this.filterInputs.training = value;
        }
      }

      if (key === "trainer") {
        if (!value) {
          delete this.filterInputs?.trainer;
        } else {
          this.filterInputs.trainer = value;
        }
      }

      if (key === "dates") {
        if (!value.startDate && !value.endDate) {
          delete this.filterInputs?.dateFrom;
          delete this.filterInputs?.dateTo;
        } else {
          this.filterInputs.dateFrom = value.startDate;
          this.filterInputs.dateTo = value.endDate;
        }
      }
      if (key === "status") {
        if (!value) {
          delete this.filterInputs?.status;
        } else {
          this.filterInputs.status = value;
        }
      }
      this.variables.limit = 10;
      this.variables.skip = 0;
      this.refetch();
    },
    async refetch() {
      this.$apollo.queries.getTrainingRegistrations.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: this.filterInputs,
      });
      // this.$apollo.queries.getTrainingRegistrations.skip = false;
    },
    closeModel() {
      this.assignCourseModal = false;
    },
    onNewAssigning() {
      this.assignCourseModal = false;
      this.refetch();
      this.$emit("onStatusUpdate");
    },
    deleteTrainingRegistration(id) {
      this.$dialog
        .confirm(this.$t("user.registration.confirmDelete"), { loader: true })
        .then(dialog => {
          deleteTrainingRegistration(id).then(res => {
            if (res.data) this.refetch();
            if (res.error) this.onError("delete");

            dialog?.close();
          });
        })
        .catch(_ => {});
    },
  },
};
</script>
